import { useState } from "react";

import { PropallyApiFactory } from "@/module/CustomApiFactory";

interface UseApproveAssesmentProposal {
  approveAssesmentProposal: (id: number) => Promise<boolean>;
  loading: boolean;
  error: string;
}

export const useApproveAssesmentProposal = (): UseApproveAssesmentProposal => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fp = PropallyApiFactory();

  const approveAssesmentProposal = async (id: number): Promise<boolean> => {
    setLoading(true);
    setError("");

    try {
      const res = await fp.v1AssessmentProposalsAssessmentProposalIdApprovedPatch(
        id,
        { is_approved: true },
        { withCredentials: true }
      );

      return res.status === 200;
    } catch (e: any) {
      console.error(e);
      setError(e?.message || "不明なエラー");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { approveAssesmentProposal, loading, error };
};
